<template>
  <div class="wrapper">
    <parallax class="section page-header header-filter" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div class="md-layout-item md-size-50 md-small-size-70 md-xsmall-size-100">
            <h1 class="title">Relentless Innovation</h1>
            <h4>
              Driven by an insatiable need to innovate, IB Labs is a full-cycle custom problem solver specializing in development of leading-edge data-driven applications for demanding enterprises.
              <br />
              <br />Caught in the never-ending 'Research - Analyize - Create' cycle, our firm provides full set of services required to solve any problem: requirements analysis, solution architecture, design, development, devops, project management, post-production maintenance and support.
            </h4>
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto text-center">
              <h2 class="title text-center">Let's Talk Solutions!</h2>
              <h4 class="description">
                <p>At the current pace of innovation, you don't have time to worry about technical details. Your competitors are already two steps ahead - you need a solution - NOW!</p>
                <p>More than simply great engineers, our top-flight problem solvers don't drown you in technical jargon, or reasons why it can't be done. Our extensive, real-world experience in providing smart solutions to complex problems gives you the advantage you need to get ahead of your peers and get the project complete.</p>
                <p>Let us handing the heavy technical lifting; and let you get back to what you're good at - creating!</p>
              </h4>
              <h4>&nbsp;</h4>
            </div>
          </div>
        </div>
        <div class="section" :style="bgImage" />
        <div class="section">
          <div class="md-layout">
            <div class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto text-center">
              <h2 class="title text-center">Let's Talk Process!</h2>
              <h4 class="description">
                <p>Through years of experience, our team has devloped a unique methodology to quickly realizing solutions. We call it the Research - Analyize - Create cycle.</p>
                <p>Although superficially similar to other methodologies, our approach offers some distinct advantages when it comes to bringing a solution quickly to market - before your competitors!</p>
              </h4>
              <div class="features text-center">
                <div class="md-layout">
                  <div class="md-layout-item md-medium-size-33 md-small-size-100">
                    <div class="info">
                      <div class="icon icon-info">
                        <img src="../assets/img/026  Chemistry-Solid.svg" />
                      </div>
                      <h4 class="info-title">Research</h4>
                      <p>At its core, Research is the collection data. However, great care must be excercised to ensure Biases don't intrude into the process. By maintaining a clear separation between Research and Analysis Phases, these Biases can be recognized and mitigated.</p>
                    </div>
                  </div>
                  <div class="md-layout-item md-medium-size-33 md-small-size-100">
                    <div class="info">
                      <div class="icon icon-success">
                        <img src="../assets/img/017  Recheck Code-Solid.svg" />
                      </div>
                      <h4 class="info-title">Analyze</h4>
                      <p>Our approach to a analysis is a bit unique. By adhering to a strict Deconstruct - Reconstruct methodology we can quickly distill the information collected in the Research Phase into Core Principals for use in the Create Phase.</p>
                    </div>
                  </div>
                  <div class="md-layout-item md-medium-size-33 md-small-size-100">
                    <div class="info">
                      <div class="icon icon-danger">
                        <img src="../assets/img/011  Program Statistics-Solid.svg" />
                      </div>
                      <h4 class="info-title">Create</h4>
                      <p>The Create phase combines the core principles gleaned from the analysis phase with best-in-class engineering techniques. By this phase we have a clear understanding of the Problem and Principles involved; and the solution can be crafted and produced quite quickly.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="section bg2" :style="bgImage2">
          <h1>&nbsp;</h1>
        </div>
        <div class="section section-contacts">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto">
                <h2 class="text-center title">Lets Talk You!</h2>
                <h4 class="text-center description">
                  If you feel we are a good fit for your next big idea, give us
                  a shout!
                </h4>
                <form class="contact-form" novalidate @submit.prevent="send">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-50">
                      <md-field :class="getValidationClass('name')">
                        <label class="form__label">Your Name</label>
                        <md-input
                          v-model.lazy="$v.form.name.$model"
                          type="text"
                          required
                          class="form__input"
                        ></md-input>
                        <span class="md-error" v-if="!$v.form.name.required">Name is required</span>
                        <span
                          class="md-error"
                          v-if="!$v.form.name.minLength"
                        >Name must have at least {{$v.form.name.$params.minLength.min}} letters</span>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-50">
                      <md-field :class="getValidationClass('email')">
                        <label>Your Email</label>
                        <md-input v-model="$v.form.email.$model" type="email" required></md-input>
                        <span class="md-error" v-if="!$v.form.email.required">Email is required</span>
                        <span
                          class="md-error"
                          v-if="!$v.form.email.minLength"
                        >Email must have at least {{$v.form.name.$params.minLength.min}} letters</span>
                      </md-field>
                    </div>
                  </div>
                  <md-field :class="getValidationClass('message')">
                    <label>Your Next Big Idea, and how we can help</label>
                    <md-textarea v-model="$v.form.message.$model" required></md-textarea>
                    <span class="md-error" v-if="!$v.form.message.required">Message is required</span>
                    <span
                      class="md-error"
                      v-if="!$v.form.message.minLength"
                    >Your message must have at least {{$v.form.message.$params.minLength.min}} letters</span>
                  </md-field>
                  <div class="md-layout">
                    <div class="md-layout-item md-size-33 mx-auto text-center">
                      <md-button type="submit" class="md-primary">Send Message</md-button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="false">
      <div class="md-snackbar md-position-center md-theme-demo-light">
        <div class="md-snackbar-content">
          <span>Your message has been Sent!</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";
import axios from "axios";

export default {
  bodyClass: "landing-page",
  data() {
    return {
      form: {
        name: null,
        email: null,
        message: null
      },
      uis: "n",
      formTouched: null,
      errors: []
    };
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/bg2.jpg")
    },
    image: {
      type: String,
      default: require("@/assets/img/bg.jpg")
    },
    image2: {
      type: String,
      default: require("@/assets/img/section3.jpg")
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    },
    bgImage() {
      return {
        backgroundImage: `url(${this.image})`
      };
    },
    bgImage2() {
      return {
        backgroundImage: `url(${this.image2})`
      };
    }
  },
  methods: {
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName];

      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty
        };
      }
    },
    validEmail: function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    send: function(e) {
      this.$v.$touch();
      if (!this.$v.$dirty) {
        this.$notify({
          message: "Please fill out the form.",
          icon: "error_outline",
          horizontalAlign: "left",
          verticalAlign: "bottom",
          type: "3"
        });
        return false;
      }
      if (this.$v.$invalid) {
        this.$notify({
          message: "Please correct the errors",
          icon: "error_outline",
          horizontalAlign: "left",
          verticalAlign: "bottom",
          type: "3"
        });
        return false;
      } else {
        axios
          .post(
            `https://us-central1-iblabscorporate.cloudfunctions.net/sendmail`,
            {
              from: this.form.email,
              subject: "Web Message From " + this.form.name,
              text: this.form.message
            }
          )
          .then(response => {
            this.$notify({
              message: "Message Sent. Thank You!",
              icon: "done_outline",
              horizontalAlign: "left",
              verticalAlign: "bottom",
              type: "4"
            });
            this.clearForm();
          })
          .catch(e => {
            this.$notify({
              message: e,
              icon: "error_outline",
              horizontalAlign: "left",
              verticalAlign: "bottom",
              type: "2"
            });
            this.errors.push(e);
          });
      }
    },
    clearForm: function() {
      this.$v.$reset();
      this.form.name = null;
      this.form.email = null;
      this.form.message = null;
    }
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(4)
      },
      email: {
        required,
        minLength: minLength(4)
      },
      message: {
        required,
        minLength: minLength(4)
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
.description > p {
  margin-bottom: 25px;
  font-size: 1.15em;
}
.bg2 {
  background-repeat: no-repeat;
  background-size: cover;
  height: 100px;
}
.md-field.md-theme-default.md-invalid:after {
  background-color: #ff1744;
  background-color: var(--md-theme-demo-light-fieldvariant, #ff1744);
}
</style>
